import api from './api';

// Group / index reference data for the strategy builder.
//
// Calls the MAIN backend (:3002) self-contained read endpoints over the
// stable IndicesControl table. Groups are GLOBAL reference data (not
// per-user), so no identity/scoping is involved — unlike the watchlist.
//
// Groups come from the curated AMXIDX index list and are keyed by the
// canonical `group_token`. Constituents are fetched by that token —
// no name ambiguity.
//
// Contract:
//   GET /strategy-groups/groups
//     -> { data: [{ group_token, name, exchange }] }
//   GET /strategy-groups/constituents?token=<group_token>
//     -> { data: [{ symbol, token }] }
export const strategyGroupsService = {
  getGroups: () => api.get('/strategy-groups/groups'),
  getGroupConstituents: (groupToken) =>
    api.get('/strategy-groups/constituents', { params: { token: groupToken } }),
};

export default strategyGroupsService;
